import React from 'react';
import { X, AlertTriangle } from 'lucide-react';
function StatusConfirmModal({ isOpen, onClose, employee, onConfirm }) {
    if (!isOpen || !employee) return null
  
    const newStatus = !employee.active
    const isDeactivating = !newStatus
  
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg w-full max-w-md">
          <div className="flex justify-between items-center p-6 border-b border-gray-100">
            <h2 className="text-xl font-semibold text-gray-900">{isDeactivating ? "Deactivate" : "Activate"} Employee</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-500 transition-colors">
              <X className="w-6 h-6" />
            </button>
          </div>
  
          <div className="p-6">
            <div
              className={`flex items-center justify-center w-12 h-12 rounded-full mx-auto mb-4 ${
                isDeactivating ? "bg-red-100" : "bg-green-100"
              }`}
            >
              <AlertTriangle className={`w-6 h-6 ${isDeactivating ? "text-red-600" : "text-green-600"}`} />
            </div>
  
            <p className="text-center text-gray-600 mb-6">
              Are you sure you want to {isDeactivating ? "deactivate" : "activate"}{" "}
              <span className="font-semibold">{employee.name}</span>?
              {isDeactivating && (
                <span className="block mt-2 text-sm text-red-600">This will revoke their access to the system.</span>
              )}
            </p>
  
            <div className="flex justify-end gap-4">
              <button
                onClick={onClose}
                className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={onConfirm}
                className={`px-4 py-2 text-white rounded-lg transition-colors ${
                  isDeactivating ? "bg-red-600 hover:bg-red-700" : "bg-green-600 hover:bg-green-700"
                }`}
              >
                {isDeactivating ? "Deactivate" : "Activate"} Employee
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
  
  

export default StatusConfirmModal;